__turbopack_context__.v({
  "author-follow": "_9lJV1G_author-follow",
  "author-follow-text": "_9lJV1G_author-follow-text",
  "author-info-icon": "_9lJV1G_author-info-icon",
});
